import { z } from 'zod';
import { AuditLogSchema, AuditLogActorSchema } from '../../../../entities/audit-log';
export const ListSuperAdminAuditLogsRequestSchema = z.object({
    tenantId: z.string().optional(),
    entityType: z.string().optional(),
    entityId: z.string().optional(),
    actorId: z.string().optional(),
    action: z.string().optional(),
    dateFrom: z.string().optional(),
    dateTo: z.string().optional(),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(25)
});
export const ListSuperAdminAuditLogsResponseSchema = z.object({
    logs: z.array(AuditLogSchema),
    actors: z.record(z.string(), AuditLogActorSchema),
    total: z.number(),
    page: z.number(),
    limit: z.number()
});

//# sourceMappingURL=list-superadmin-audit-logs.schema.js.map